export default __webpack_public_path__ + "static/media/logo.bb70c1f4.png";